import { ErrorContent } from '../../types';
import { ErrorKeys, MessageKeys } from '../../validators';
import { t } from 'i18next';

export const getNotificationsConfig = () =>
  new Map<string | undefined, ErrorContent>([
    [
      ErrorKeys.FIELDS_MISSING,
      {
        title: t('ui.snackbar.review-form-fields-missing'),
        message: t(MessageKeys.FILL_REQUIRED_FIELDS),
        hideAfter: 3000,
      },
    ],
    [
      ErrorKeys.WRONG_EMAIL,
      {
        title: t('ui.snackbar.review-form-wrong-email'),
        message: t(MessageKeys.CHECK_YOUR_EMAIL),
        hasButton: true,
      },
    ],
    [
      ErrorKeys.FAILED_TO_POST_ERROR,
      {
        title: t('ui.snackbar.review-form-failed-to-post-error'),
        message: t(MessageKeys.FAILED_TO_POST),
        hasButton: true,
      },
    ],
    [
      ErrorKeys.MAX_LENGTH_EXCEEDED,
      {
        title: t('ui.snackbar.review-form-max-length-exceeded'),
        message: t(MessageKeys.REDUCE_REVIEW_LENGTH),
        hasButton: true,
      },
    ],
  ]);
